import { FC, useMemo } from 'react';
import { useAppContext, View } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';

import { triggerHaptic } from '../../utils/haptics';
import { useTranslation } from 'react-i18next';

export const NotificationBell: FC = () => {
    const { t } = useTranslation();
    const { goToPage, db } = useAppContext();
    const { user } = useAuth();

    const unreadCount = useMemo(() => {
        if (!db || !user) return 0;
        const notifications = db.notifications || [];
        return notifications.filter((n: any) => n.playerId === user.uid && !n.read).length;
    }, [db, user]);

    const handleClick = () => {
        triggerHaptic();
        goToPage(View.INBOX);
    };

    if (!user) return null;

    return (
        <button
            onClick={handleClick}
            className="relative p-2 text-text-secondary hover:text-primary transition-colors"
            title={t('navbar.notifications', 'Notifications')}
        >
            <span className="material-symbols-outlined">notifications</span>
            {unreadCount > 0 && (
                <span className="absolute top-0 right-0 bg-danger text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {unreadCount > 9 ? '9+' : unreadCount}
                </span>
            )}
        </button>
    );
};
